import React from 'react'
import '../styles/potential.css'
import { useAuth } from '../../../../common/store/authStore'
import { Trophy, Gamepad2, Users, Zap, ArrowRight, Star, Target, Award } from 'lucide-react'
import { Link } from 'react-router-dom'

function ShowPotential() {
  const { authenticatedUser } = useAuth();
  const isAuthenticated = !!authenticatedUser;

  return (
    <section className="show-potential-section">
      <div className="potential-background">
        <div className="potential-overlay"></div>
        <div className="potential-particles"></div>
      </div>
      
      <div className="potential-container">
        <div className="potential-content">
          <div className="potential-left">
            <div className="section-badge">
              <Star className="badge-icon" size={20} />
              <span>SHOW YOUR POTENTIAL</span>
            </div>
            
            <h2 className="section-title">
              Unleash Your <span className="title-highlight">Gaming</span> Potential
            </h2>
            
            <p className="section-description">
              More and more people decide to join the eSport. 
              And it is not only a booming sector but a world full of innovation and benefits.
            </p>
            
            <p className="section-description">
              And not only for individual players or the most professional teams. 
              But also a way for friends to connect, for companies it is becoming an innovative method of building and training their work teams.
            </p>
            
            <div className="potential-stats">
              <div className="stat-item">
                <Target className="stat-icon" size={24} />
                <div className="stat-content">
                  <span className="stat-number">1.5K+</span>
                  <span className="stat-label">Active Players</span>
                </div>
              </div>
              <div className="stat-item">
                <Award className="stat-icon" size={24} />
                <div className="stat-content">
                  <span className="stat-number">$50K+</span>
                  <span className="stat-label">Total Prizes</span>
                </div>
              </div>
              <div className="stat-item">
                <Trophy className="stat-icon" size={24} />
                <div className="stat-content">
                  <span className="stat-number">500+</span>
                  <span className="stat-label">Tournaments</span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="potential-right">
            <div className="steps-container">
              {isAuthenticated ? (
                <a href="#join-tournaments-section" className="step-item">
                  <div className="step-icon">
                    <Users className="step-icon-svg" size={24} />
                  </div>
                  <div className="step-content">
                    <h3 className="step-title">Join Tournaments</h3>
                    <p className="step-description">Browse and join exciting tournaments to showcase your skills.</p>
                  </div>
                  <ArrowRight className="step-arrow" size={20} />
                </a>
              ) : (
                <Link to='/sign-up' className="step-item">
                  <div className="step-icon">
                    <Users className="step-icon-svg" size={24} />
                  </div>
                  <div className="step-content">
                    <h3 className="step-title">Register Totally Free</h3>
                    <p className="step-description">Join our community of gamers and start your journey to greatness.</p>
                  </div>
                  <ArrowRight className="step-arrow" size={20} />
                </Link>
              )}
              
              <Link to='/games' className="step-item">
                <div className="step-icon">
                  <Gamepad2 className="step-icon-svg" size={24} />
                </div>
                <div className="step-content">
                  <h3 className="step-title">Find Your Game</h3>
                  <p className="step-description">Choose from our wide selection of competitive games and tournaments.</p>
                </div>
                <ArrowRight className="step-arrow" size={20} />
              </Link>
              
              {isAuthenticated ? (
                <Link to='/create-tournament' className="step-item">
                  <div className="step-icon">
                    <Trophy className="step-icon-svg" size={24} />
                  </div>
                  <div className="step-content">
                    <h3 className="step-title">Create Free/Paid Tournaments</h3>
                    <p className="step-description">Host your own tournaments and build your gaming community.</p>
                  </div>
                  <ArrowRight className="step-arrow" size={20} />
                </Link>
              ) : (
                <Link to='/login' className="step-item">
                  <div className="step-icon">
                    <Trophy className="step-icon-svg" size={24} />
                  </div>
                  <div className="step-content">
                    <h3 className="step-title">Create Free/Paid Tournaments</h3>
                    <p className="step-description">Sign up to host your own tournaments and build your gaming community.</p>
                  </div>
                  <ArrowRight className="step-arrow" size={20} />
                </Link>
              )}
              
              <a href="#join-tournaments-section" className="step-item">
                <div className="step-icon">
                  <Zap className="step-icon-svg" size={24} />
                </div>
                <div className="step-content">
                  <h3 className="step-title">Play to Win Different Rewards</h3>
                  <p className="step-description">Compete and earn rewards, prizes, and recognition in the gaming world.</p>
                </div>
                <ArrowRight className="step-arrow" size={20} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ShowPotential
